var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStyling = function SvgStyling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(30 32 32.088)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M30 22v17.21a1 1 0 0 0 .12.474L32 43.176l1.88-3.492a1 1 0 0 0 .12-.474V22a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1zm3-3a3 3 0 0 1 3 3v17.21a3 3 0 0 1-.359 1.422l-1.88 3.493a2 2 0 0 1-3.522 0l-1.88-3.493A3 3 0 0 1 28 39.21V22a3 3 0 0 1 3-3h2zm-4.5 19.356v-2h7v2h-7z"
  }))));
};
export default SvgStyling;